import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { jetStreamInstance } from '../../../../shared/components';
import { SortableHeaderCell } from '../../../shared_elements';
const BankHeader = ({ sortInfo, createSortHandler }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{width: '105px' }}>Action(s)</TableCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="lessor">{jetStreamInstance ? "Lessor/Holdco" : "Lessor"}</SortableHeaderCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="name">Bank Name</SortableHeaderCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="account_name">Account Holder Name</SortableHeaderCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="account_number">Account Number</SortableHeaderCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="swift_code">SWIFT Code</SortableHeaderCell>
                <SortableHeaderCell sortInfo={sortInfo} createSortHandler={createSortHandler} sortKey="status" style={{ minWidth: '125px' }}>Status</SortableHeaderCell>
            </TableRow>
        </TableHead>
    )
}
export default BankHeader;